import { createContext, useContext } from "react";
function createOptionalContextFactory(name, initialValue) {
  const OptionalContext = createContext(initialValue);
  OptionalContext.displayName = name;
  const useOptionalContext = () => {
    return useContext(OptionalContext) ?? initialValue;
  };
  return [OptionalContext, useOptionalContext];
}
export {
  createOptionalContextFactory
};
//# sourceMappingURL=createOptionalContextFactory.js.map
